import { useEffect, useMemo, useState } from "react";
import { allOrders } from "../../CanteenUsers/OrderSlice";
import { useDispatch, useSelector } from "react-redux";

const useAddOrders = () => {
  const dispatch = useDispatch();
  const { orders = [], loading = false } = useSelector((state) => state.orders || {});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

const canteenType = useSelector((state) => state.canteenType.type);

useEffect(() => {
  dispatch(allOrders(canteenType));
}, [canteenType, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "order_uniq_id",
        Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
      },
      {
        Header: "Customer",
        accessor: "user",
            Cell: ({ value }) => <div className="text-nowrap">{value.full_name}</div>,
      },
      {
        Header: "Items name",
        accessor: "order_items",
        Cell: ({ value }) => (
          <ul className="pl-3">
            {value?.map((item, index) => (
              <li key={index} className="list-disc text-left">
                {item.item_name}
              </li>
            ))}
          </ul>
        ),
      },
      {
        Header: "Quantity",
        accessor: "quantity",
        headerAlign: "text-center",
        cellAlign: "text-center",
        Cell: ({ row }) => (
          <ul className="">
            {row.original.order_items?.map((item, index) => (
              <li key={index} className=" md:text-center">
                {item.quantity}
              </li>
            ))}
          </ul>
        ),
      },
      {
        Header: "Item price",
        accessor: "price",
        Cell: ({ row }) => (
          <ul className="">
            {row.original.order_items?.map((item, index) => (
              <li key={index} className="md:text-center">
                {item.total_price}
              </li>
            ))}
          </ul>
        ),
      },
      {
        Header: "TOTAL price",
        accessor: "total_price",
      },
      {
        Header: "mode",
        accessor: "order_type",
      },
      {
        Header: "date",
        accessor: "date",
        Cell: ({ value }) => <p>{value?.split("T")[0]}</p>
      },
      {
        Header: "Status",
        accessor: "status",
        headerAlign: "text-center",
        cellAlign: "text-center",
        disableSortBy: true,
        Cell: ({ value }) => (
          <p
            className={`text-xs md:text-sm font-medium flex justify-center items-center rounded-3xl w-[100px] md:w-auto px-4 py-[6px] 
            ${value === "pending"
                ? "text-yellow bg-yellow bg-opacity-[10%]"
                : value === "completed" ?
                  "text-green bg-green bg-opacity-[10%]"
                  : "text-red bg-red bg-opacity-[10%]"
              }`}
          >
            {value}
          </p>
        ),
      },
    ],
    []
  );

  const data = orders || [];

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return {
    columns,
    currentRows,
    totalRows: data.length,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading
  };
};

export default useAddOrders;